import React from 'react';
import { useCss } from 'app/utils/css';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';

export enum H2Variant {
  H2_BASE_STYLE,
  H2_HTTP_STATUS_STYLE,
}

const baseStyle = {
  fontSize: '1.4em',
  fontWeight: 600,
  lineHeight: '1.4',
  margin: '0.4em 0',
};

const H2 = ({ variant = H2Variant.H2_BASE_STYLE, children }: {variant?: H2Variant, children: React.ReactNode }) => {
  const css = useCss();
  const breakpoint = usePageBreakpoint();
  const isNarrow = breakpoint <= NumericBreakpoint.Narrow;

  return (
    <h2 className={css(`h2`, [
      variant === H2Variant.H2_BASE_STYLE && {
        ...baseStyle,
      },
      variant === H2Variant.H2_HTTP_STATUS_STYLE && {
        margin: '0',
        fontSize: isNarrow ? '1.4em' : '1.7em',
      },
    ])}
    >
      {children}
    </h2>
  );
};
export default H2;
